<template>
  <product-list
    :productService = productService
    :productComponent = productComponent
  ></product-list>
</template>

<script>
  import ProductList from '@/components/Common/Product/ProductList'

  export default {
    props: {
      productService: Object,
      productComponent: String,
    },
    components: {
      ProductList
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Products/Overview.vue